(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/hero/assets/javascripts/hero.js') >= 0) return;  svs.modules.push('/components/lb-ui/hero/assets/javascripts/hero.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const Icon = svs.ui.ReactIcon;
const clx = svs.components.lbUtils.clx;
const BrandCube = svs.components.lbUi.brandCube.BrandCube;
const _svs$components$lbUi$ = svs.components.lbUi.hero.components,
  HeroImage = _svs$components$lbUi$.HeroImage,
  HeroLoader = _svs$components$lbUi$.HeroLoader;
const Hero = _ref => {
  let branding = _ref.branding,
    children = _ref.children,
    cube = _ref.cube,
    hasInvertedArrow = _ref.hasInvertedArrow,
    heroImage = _ref.image,
    isLoading = _ref.isLoading,
    order = _ref.order,
    tab = _ref.tab;
  const heroRef = useRef();
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  const _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    width = _useState4[0],
    setWidth = _useState4[1];
  const _useState5 = useState(() => isLoading),
    _useState6 = _slicedToArray(_useState5, 2),
    loadingState = _useState6[0],
    setLoadingState = _useState6[1];
  const onLoadCallback = useCallback(() => {
    setLoadingState(false);
  }, []);
  useEffect(() => {
    const el = heroRef.current;
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        var _entry$contentRect, _entry$contentRect2;
        if ((entry === null || entry === void 0 || (_entry$contentRect = entry.contentRect) === null || _entry$contentRect === void 0 ? void 0 : _entry$contentRect.height) !== height || (entry === null || entry === void 0 || (_entry$contentRect2 = entry.contentRect) === null || _entry$contentRect2 === void 0 ? void 0 : _entry$contentRect2.width) !== width) {
          setHeight(entry.contentRect.height);
          setWidth(entry.contentRect.width);
        }
      }
    });
    resizeObserver.observe(el);
    return () => {
      resizeObserver.unobserve(el);
    };
  }, [height, width]);
  return React.createElement("div", {
    className: clx('hero-v2', branding, "hero-".concat(order), {
      'invert-arrow': hasInvertedArrow,
      'hero-loading': loadingState
    }),
    ref: heroRef,
    style: {
      '--height': "".concat(Math.ceil(height / 2), "px"),
      '--width': "".concat(Math.ceil(width / 2), "px")
    }
  }, React.createElement("div", {
    className: "hero-container"
  }, React.createElement("div", {
    className: "hero-content"
  }, children, React.createElement("div", {
    className: "hero-angles"
  })), React.createElement(HeroImage, {
    image: heroImage,
    onLoadCallback: onLoadCallback
  }), React.createElement("div", {
    className: "hero-brand-cube"
  }, React.createElement(BrandCube, {
    productId: cube
  })), React.createElement(HeroLoader, null), tab && React.createElement("div", {
    className: "hero-tab hero-icon"
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: tab,
    size: "400"
  }))));
};
Hero.defaultProps = {
  branding: 'default',
  hasInvertedArrow: false,
  isLoading: false,
  order: 'ltr'
};
setGlobal('svs.components.lbUi.hero.Hero', Hero);

 })(window);